// pages/Dashboard.jsx
import OtpVerification from "../../components/home/authComponents/OtpVerification";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <OtpVerification />
    </HomeLayout>
  );
}
